import React from "react";
import { useTranslation } from "react-i18next";

import { Gallery } from "./gallery";
import { PageTitle } from "./pageTitle";
import { GridElements } from "./gridelements";
import { Team } from "./Team";
import JsonData from "../data/data.json";
import "../App.css";

const Foru = () => {
  const { t } = useTranslation("foru");
  const { t: tLanding } = useTranslation("landing");
  const brand = JsonData?.About?.nameBank || "CIRYON";
  const foru2 = { line: tLanding("gridForu2", { returnObjects: true }) };
  const line3 = { line: tLanding("gridLine3", { returnObjects: true }) };

  return (
    <>
      <PageTitle title={t("title")} sub2={t("sub2", { brand })} />
      <GridElements data={foru2} />
      <GridElements data={line3} />
      <Team />
      <Gallery />
    </>
  );
};

export default Foru;
